import { render, staticRenderFns } from "./loadingEmbed.vue?vue&type=template&id=9ce45182"
import script from "./loadingEmbed.vue?vue&type=script&lang=js"
export * from "./loadingEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports